'use client';

import { useState, useCallback } from 'react';

/**
 * Drop-in replacement for Chakra useDisclosure.
 * Returns { isOpen, onOpen, onClose, onToggle }.
 */
export function useDisclosure(defaultIsOpen = false) {
  const [isOpen, setIsOpen] = useState(defaultIsOpen);
  const onOpen = useCallback(() => setIsOpen(true), []);
  const onClose = useCallback(() => setIsOpen(false), []);
  const onToggle = useCallback(() => setIsOpen((prev) => !prev), []);
  return { isOpen, onOpen, onClose, onToggle };
}
